import { getProxyUrl, getPublicLang } from 'academy-common-lib/utils/url';

// @ts-expect-error Could not find a declaration file for module
import defaultShareImage from 'bender-url!../../images/default-share-image.png';
// @ts-expect-error Could not find a declaration file for module
import academyLogo from 'bender-url!../../images/hubspot-academy-logo-color.svg';
import PublicLandingPagePrimaryDetails from '../features/publicPresentation/components/PublicLandingPagePrimaryDetails';
import PublicLandingPageSecondaryDetails from '../features/publicPresentation/components/PublicLandingPageSecondaryDetails';
import PublicPageLayout from '../features/publicLayout/components/PublicPageLayout';
import PublicPageVideoSection from '../features/publicPresentation/components/PublicPageVideoSection';
import PublicPageProfessorsSection from '../features/publicPresentation/components/PublicPageProfessorsSection';
import PublicPageRelatedContentSection from '../features/publicPresentation/components/PublicPageRelatedContentSection';
import PublicPageTranscriptSection from '../features/publicPresentation/components/PublicPageTranscriptSection';
import PublicPageAboutAcademySection from '../features/publicPresentation/components/PublicPageAboutAcademySection';
import PublicPageShareSection from '../features/publicPresentation/components/PublicPageShareSection';
import { usePublicLesson } from '../features/publicLesson/publicLessonQueries';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import DocumentHead from '../features/publicSeo/components/DocumentHead';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ApiError from '../components/ApiError';
import { NavMarker } from 'react-rhumb';
import OpenGraph from '../features/publicSeo/components/OpenGraph';
import I18n from 'I18n';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Schema from '../features/publicSeo/components/Schema';
import usageTracker from '../utils/usageTracker';
import { durationToSchema } from '../utils/time';
import HorizontalLayoutContainer from '../features/publicLayout/components/HorizontalLayoutContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicLessonPage = ({
  match: {
    params: {
      pagePath
    }
  }
}) => {
  useEffect(() => {
    usageTracker.track('pageView', {
      screen: 'course-page',
      subscreen: pagePath
    });
  }, [pagePath]);
  const location = useLocation();
  const {
    publicLesson,
    publicLessonLoading,
    publicLessonError
  } = usePublicLesson(pagePath, getPublicLang());
  const {
    seoCustomTeaser,
    teaser,
    description,
    headline,
    name,
    seoPageTitle,
    seoParentCourse,
    id,
    personas,
    learnings,
    availableLanguages,
    contentTypeCounts,
    duration,
    subCategories,
    seoDetailedProfessorRelatedContent,
    seoDetailedRelatedContent,
    seoTranscript,
    seoTranscriptTitle,
    titleTag,
    canonicalUrl,
    seoThumbnailAltText,
    previewThumbnailRectangleUrl,
    videoAsset,
    languageLinkedContent
  } = publicLesson || {};
  const availableSupportedLanguages = (availableLanguages || []).filter(lang => supportedPublicLanguages.includes(lang));
  const browserTabTitle = titleTag || seoPageTitle || name;
  const descriptionText = (seoCustomTeaser || teaser || description || '').trim();
  useEffect(() => {
    if (browserTabTitle) {
      document.title = browserTabTitle;
    }
  }, [browserTabTitle]);
  const embeddedSignupRef = useRef(null);
  if (!publicLesson && publicLessonLoading) {
    return /*#__PURE__*/_jsx(PublicPageLayout, {
      footerType: "minimal",
      children: /*#__PURE__*/_jsx(LoadingOverlay, {
        contextual: true,
        layout: "centered"
      })
    });
  }
  if (!publicLesson || publicLessonError) {
    var _publicLessonError$st;
    return /*#__PURE__*/_jsxs(PublicPageLayout, {
      footerType: "minimal",
      children: [window.prerenderReady = true, /*#__PURE__*/_jsx(ApiError, {
        error: publicLessonError,
        errorMarker: "LESSON_LANDING_PAGE_LOAD_FAILURE",
        forbiddenErrorMarker: "LESSON_LANDING_PAGE_FORBIDDEN",
        notFoundErrorMarker: "LESSON_LANDING_PAGE_NOT_FOUND"
      }), /*#__PURE__*/_jsx(DocumentHead, {
        children: /*#__PURE__*/_jsx("meta", {
          content: (publicLessonError === null || publicLessonError === void 0 || (_publicLessonError$st = publicLessonError.status) === null || _publicLessonError$st === void 0 ? void 0 : _publicLessonError$st.toString()) || '500',
          name: "prerender-status-code"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(PublicPageLayout, {
    availableLanguages: availableSupportedLanguages.length ? availableSupportedLanguages : undefined,
    contentType: "lesson",
    footerType: "minimal",
    languageLinkedContent: languageLinkedContent,
    pagePath: pagePath,
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "LESSON_LANDING_PAGE_LOAD"
    }), window.prerenderReady = true, /*#__PURE__*/_jsxs(DocumentHead, {
      children: [/*#__PURE__*/_jsx("link", {
        href: getProxyUrl(`/lessons/${canonicalUrl || pagePath}`),
        rel: "canonical"
      }), availableSupportedLanguages.filter(lang => lang !== getPublicLang()).sort().map(lang => /*#__PURE__*/_jsx("link", {
        href: getProxyUrl(location.pathname, lang),
        hrefLang: lang,
        rel: "alternate"
      }, lang)), /*#__PURE__*/_jsx("meta", {
        content: descriptionText,
        name: "description"
      }), /*#__PURE__*/_jsx(OpenGraph, {
        description: descriptionText,
        image: previewThumbnailRectangleUrl || defaultShareImage.replace('//', 'https://'),
        imageAlt: seoThumbnailAltText || I18n.text('academyPublic.defaultThumbnailAltText'),
        title: seoPageTitle || name,
        url: getProxyUrl(`/lessons/${canonicalUrl || pagePath}`)
      })]
    }), /*#__PURE__*/_jsx(Schema, {
      object: {
        ['@type']: 'Course',
        name: seoPageTitle || name,
        description: descriptionText,
        isAccessibleForFree: true,
        inLanguage: getPublicLang(),
        creator: (seoDetailedProfessorRelatedContent === null || seoDetailedProfessorRelatedContent === void 0 ? void 0 : seoDetailedProfessorRelatedContent[0]) && {
          ['@type']: 'Person',
          name: seoDetailedProfessorRelatedContent[0].name
        },
        about: {
          name: I18n.text(`academyPublic.categories.${subCategories === null || subCategories === void 0 ? void 0 : subCategories[0]}`)
        },
        provider: {
          ['@type']: 'Organization',
          name: 'HubSpot Academy',
          sameAs: 'https://academy.hubspot.com',
          logo: academyLogo.replace('//', 'https://')
        },
        timeRequired: duration ? durationToSchema(duration) : undefined,
        hasCourseInstance: [{
          '@type': 'CourseInstance',
          courseMode: 'Online',
          courseWorkload: duration ? durationToSchema(duration) : undefined,
          instructor: (seoDetailedProfessorRelatedContent === null || seoDetailedProfessorRelatedContent === void 0 ? void 0 : seoDetailedProfessorRelatedContent[0]) && {
            '@type': 'Person',
            name: seoDetailedProfessorRelatedContent === null || seoDetailedProfessorRelatedContent === void 0 ? void 0 : seoDetailedProfessorRelatedContent[0].name,
            description: descriptionText,
            image: seoDetailedProfessorRelatedContent === null || seoDetailedProfessorRelatedContent === void 0 ? void 0 : seoDetailedProfessorRelatedContent[0].professorImage
          }
        }],
        offers: {
          '@type': 'Offer',
          category: 'Free'
        }
      }
    }), /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
      children: [/*#__PURE__*/_jsx(PublicLandingPagePrimaryDetails, {
        contentType: "LESSON",
        description: descriptionText,
        headline: headline,
        id: id,
        name: seoPageTitle || name,
        pagePath: pagePath,
        parentName: seoParentCourse ? seoParentCourse.label || seoParentCourse.localizedName : null,
        parentPath: seoParentCourse ? seoParentCourse.pagePath : null,
        ref: embeddedSignupRef
      }), /*#__PURE__*/_jsx(PublicLandingPageSecondaryDetails, {
        availableLanguages: availableSupportedLanguages,
        contentType: "LESSON",
        description: seoCustomTeaser || teaser ? description : null,
        duration: duration,
        embeddedSignupRef: embeddedSignupRef,
        learnings: learnings,
        personas: personas,
        quizCount: contentTypeCounts && contentTypeCounts.QUIZ,
        subCategories: subCategories,
        videoCount: contentTypeCounts && contentTypeCounts.VIDEO
      }), videoAsset && videoAsset.reference && videoAsset.referenceType && /*#__PURE__*/_jsx(PublicPageVideoSection, {
        creatorHubId: videoAsset.hubId || undefined,
        videoId: videoAsset.reference
      }), seoDetailedProfessorRelatedContent && !!seoDetailedProfessorRelatedContent.length && /*#__PURE__*/_jsx(PublicPageProfessorsSection, {
        contentType: "LESSON",
        lessonId: id,
        professors: seoDetailedProfessorRelatedContent
      }), seoDetailedRelatedContent && !!seoDetailedRelatedContent.length && /*#__PURE__*/_jsx(PublicPageRelatedContentSection, {
        items: seoDetailedRelatedContent
      }), seoTranscript && /*#__PURE__*/_jsx(PublicPageTranscriptSection, {
        contentType: "LESSON",
        title: seoTranscriptTitle || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.transcript.title",
          options: {
            contentTitle: name
          }
        }),
        transcript: seoTranscript
      }), /*#__PURE__*/_jsx(PublicPageAboutAcademySection, {}), /*#__PURE__*/_jsx(PublicPageShareSection, {
        contentType: "LESSON"
      })]
    })]
  });
};
export default PublicLessonPage;